<template>
  <transition name="fade">    
  <div v-show="isWaiting.isWaiting" class="is-waiting-overlay">
    <div class="inner">
        <p>{{isWaiting.message}}</p>
        <transition name="fade-fast" v-show="isWaiting.isWaiting">   
          <ThreeDots color="#ffffff" />
        </transition> 
    </div>
  </div>
  </transition>
</template>
<script>
import {ThreeDots} from 'vue-loading-spinner';

export default {
  components : {
      ThreeDots
  },
  data(){
      return {

      }
  },
  computed :{
    isWaiting(){
        return this.$store.getters.getIsWaiting
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/common/isWaiting.vue